/**
 * Configuration file for collections
 *
 * This file is where you define overrides for the default collection behaviors.
 */

module.exports = {

  /**
   * While this file can influence the behavior of collections, there is currently
   * no clear reason why you would ever need to use it.
   *
   * If you need to define collection specific behavior (such as parsing server responses
   * or defining headers to add to requests) you should do that in 'config/connections.js'.
   *
   * If you have multiple connections, and need to define which collections use each
   * connection, you should do that in 'config/models.js' as this file inherits that
   * behavior.
   *
   */

};



// WEBPACK FOOTER //
// ./config/collections.js